<template>
  <div class="client-card border" v-if="client" :class="[!client.filter.verify && client.filter.resident ? 'border-danger' : '', client.beingVerify ? 'pulse' : '']">
    <div class="client-card__panel" @click="setSelectedClient(keyItem)">
      <i class="ki-duotone ki-security-user fs-3x"
         :class="[client.filter.person ? 'text-primary' : 'text-warning', client.beingVerify ? 'opacity-0' : '']"
      >
        <i class="path1"></i>
        <i class="path2"></i>
      </i>
      <i v-if="client.beingVerify" class="ki-duotone ki-abstract-33 fs-3x text-primary verified opacity-50">
        <span class="path1"></span>
        <span class="path2"></span>
      </i>
      <div class="ms-4">
        <div
            v-if="!this.client.entrepreneur"
            class="fs-6 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip" data-bs-placement="top"
            :title="client.client.title">{{ client.client.title ? client.client.title : clientName(client.client) }}</div>
        <div
            v-else
            class="fs-6 fw-bolder text-gray-700 line-clamp"
            data-bs-toggle="tooltip" data-bs-placement="top"
            :title="this.client.entrepreneur.name ?? this.client.entrepreneur.number">
          {{ this.client.entrepreneur.name ?? this.client.entrepreneur.number }}
        </div>
        <template v-if="!(client.podft && !client.podft.success)">
          <div v-if="client.beingVerify" class="fs-8 text-primary opacity-75">Проверка документов</div>
          <div v-else class="fs-8 text-gray-400">
            <span v-if="this.module.Modal.infoCard('iin')">
              {{ this.client.entrepreneur ? this.client.entrepreneur.number : (client.client.iin ? client.client.iin : client.document?.number) }} /
            </span>
            <span v-if="this.module.Modal.infoCard('person')" class="text-primary opacity-75">{{ this.client.entrepreneur ? 'ИП' : client.filter.person ? 'Физ. лицо' : 'Юр. лицо' }}</span> /
            <span v-if="this.module.Modal.infoCard('resident')" class="text-danger opacity-75">{{ client.filter.resident ? 'Резидент' : 'Нерезидент' }}</span>
            <slot name="additional"></slot>
            <span v-if="hasPaid && (this.module.Modal.infoCard('class') && client.class && !this.client.entrepreneur)"> / Класс: <b class="text-gray-600" v-html="client.class.class"></b></span>
          </div>
          <div v-if="!client.filter.verify && client.filter.resident" class="mt-1">
            <span class="fs-8 px-3 py-1 bg-danger rounded text-white">КДП не получено.</span>
          </div>
        </template>
        <template v-else>
          <div class="fs-8 text-danger opacity-75">{{ client.podft.message}}</div>
        </template>
      </div>
      <div class="card_change" v-if="!changeDisabled">
        <slot name="change"></slot>
      </div>
    </div>
    <slot name="footer" v-if="!changeDisabled"></slot>
  </div>
</template>

<script>
export default {
  name: 'CustomerCard',
  props: {
    client: {
      type: Object,
      default: null
    },
    keyItem: 0,
    selectedClient: false,
    changeDisabled: {
      type: Boolean,
      default: false
    },
    module: {
      type: Function,
      required: true
    },
    hasPaid: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    setSelectedClient(key) {
      this.$emit('setSelectedClient', key)
    },
    clientName(info){
      return this.module.Client.clientName(info)
    }
  }
}
</script>

<style scoped>

</style>